import { CancelTokenSource } from "axios";
import { SelfServiceContainer } from "ts-types/api.types";
import axios from "./http";

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/self-service-container`;

export const getAllContainers = (
    mandateId: number,
    source: CancelTokenSource): Promise<SelfServiceContainer[]> => {

  return axios
      .get(`${apiUri}`, {params: {mandateId: mandateId}, cancelToken: source.token})
      .then(response => response.data)
};
